// src/observations/store/reducers/observations.reducer.js
import * as Actions from '../actions/accountContacts.actions';

const initialState = [];

export default function observations(state = initialState, action = {}) {
  switch (action.type) {
    case Actions.GET_ACCOUNTCONTACTS:
      return action.payload;

    case Actions.ADD_ACCOUNT_CONTACT:
      return [...state, action.payload];

    case Actions.UPDATE_ACCOUNT_CONTACT:
    case Actions.GET_ACCOUNT_CONTACT: {
      const idx = state.findIndex((o) => o.id === action.payload.id);
      const newState = [...state];
      newState[idx > -1 ? idx : state.length] = action.payload;
      return newState;
    }

    case Actions.REMOVE_ACCOUNT_CONTACT:
      return state.filter((o) => o.id !== action.payload.id);

    default:
      return state;
  }
}
